class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelectorAll('cart-items').forEach((cartItems) => { cartItems.updateQuantity(this.dataset.index, 0) });
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.checkoutButton = document.querySelector('.cart-notification-checkout-button');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooters = document.querySelectorAll('#main-cart-footer');

        cartFooters.forEach((cartFooter) => {

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {

            const elementsToReplace = document.querySelectorAll(`#${section.id} ${section.selector}, #${section.id}`);

            elementsToReplace.forEach((elementToReplace) => {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            });

          }));

          if (cartFooter) cartFooter.querySelector('.totals__subtotal-value').innerHTML = Shopify.formatMoney(parsedState.items_subtotal_price).replace(' ','');

          const lineItems = document.querySelectorAll(`#CartItem-${line}`);

          lineItems.forEach((lineItem) => {
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) { lineItem.querySelector(`[name="${name}"]`).focus(); }
          });

          this.disableLoading();


          // update subtotal in cart overlay
          cartFooter.querySelector('.totals__subtotal-value').textContent = Shopify.formatMoney(parsedState.items_subtotal_price).replace(' ','');
        });

        // update cart bubble in header
        document.querySelector('.cart-count-bubble span').textContent = parsedState.item_count;
        document.querySelector('.cart-count-bubble').setAttribute('data-count', parsedState.item_count);

        // Update checkout button in mini cart
        if (this.checkoutButton) {
          this.checkoutButton.disabled = (parsedState.item_count === 0);
        }

      }).catch(() => {
        document.querySelectorAll('#main-cart-items .loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
      });

  }

  updateLiveRegions(line, itemCount) {
    
    if (this.currentItemCount === itemCount) {

      const lineItemErrorLines = document.querySelectorAll(`#Line-item-error-${line}`);

      lineItemErrorLines.forEach((lineItemErrorLine) => {
        lineItemErrorLine
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      });
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.querySelectorAll(`#main-cart-items`).forEach((cartItems) => cartItems.classList.add('cart__items--disabled'));
    document.querySelectorAll(`#main-cart-items #CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
  }

  disableLoading() {
    const mainCartItems = document.querySelectorAll(`#main-cart-items`);

    mainCartItems.forEach((mainCartItem) => {
      mainCartItem.classList.remove('cart__items--disabled');
    });
  }
}

customElements.define('cart-items', CartItems);
